<template>
  <div
    class="marquee-text"
    :class="[
      cssClasses,
      { selected: isSelected, locked },
    ]"
    :style="[basicStyles, textShadowStyles, textBackgroundStyles]"
    v-html="text"
  />
</template>

<script>
import ElementsMixins from '../../../mixins/elements-mixins';

export default {
  name: 'MarqueeText',
  mixins: [ElementsMixins],
  computed: {
    fontSize: {
      get() {
        return this.styles.fontSize;
      },
      set(v) {
        this.updateStyles({
          id: this.id,
          propKey: 'fontSize',
          propValue: v,
        });
      },
    },
    text: {
      get() {
        const { id, text } = this.element;

        if (this.isMapped('text')) {
          return this.getDataValue(id, 'text');
        }

        return text || 'Edit the text in the right side bar.';
      },
      set(v) {
        this.updateElementProp({
          id: this.id,
          propKey: 'text',
          propValue: v,
        });
      },
    },
    element() {
      return this.getElementById(this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.marquee-text {
  display: block;
}
</style>
